@if (selectedSite$ | async) {
  <div class="container">
    <mat-form-field>
      <mat-select #matSelect
        [formControl]="representationControl"
        (selectionChange)="onChangeRepresentation($event, matSelect)">
        <mat-option [value]="viewRepresentation.TEXTURED">
          <div class="option">
            <div>{{'representation_textured' | transloco}}</div>
            @if ((isTilesetLoading$ | async) && representationControl.value == viewRepresentation.TEXTURED) {
              <div><mat-spinner strokeWidth="5"></mat-spinner></div>
            }
          </div>
        </mat-option>
        <mat-option [value]="viewRepresentation.POINT_CLOUD">
          <div class="option">
            <div>{{'representation_point_cloud' | transloco}}</div>
            @if ((isTilesetLoading$ | async) && representationControl.value == viewRepresentation.POINT_CLOUD) {
              <div><mat-spinner strokeWidth="5"></mat-spinner></div>
            }
          </div>
        </mat-option>
        @if (batchs.length > 1) {
          <mat-option
            [value]="viewRepresentation.SPLITTED_TEXTURED">
            <div class="option">
              <div>{{'representation_splitted_textured' | transloco}}</div>
              @if ((isSplittedTilesetLoading$ | async) && representationControl.value == viewRepresentation.SPLITTED_TEXTURED) {
                <div><mat-spinner strokeWidth="5"></mat-spinner></div>
              }
            </div>
          </mat-option>
        }
        @if (batchs.length > 1) {
          <mat-option
            [value]="viewRepresentation.SPLITTED_POINT_CLOUD">
            <div class="option">
              <div>{{'representation_splitted_pointcloud' | transloco}}</div>
              @if ((isSplittedTilesetLoading$ | async) && representationControl.value == viewRepresentation.SPLITTED_POINT_CLOUD) {
                <div><mat-spinner strokeWidth="5"></mat-spinner></div>
              }
            </div>
          </mat-option>
        }
        @if (batchs.length > 1) {
          <mat-option
            [value]="viewRepresentation.DIFFERENTIAL">
            <div class="option">
              <div>{{'representation_differential' | transloco}}</div>
              @if ((isTilesetLoading$ | async) && representationControl.value == viewRepresentation.DIFFERENTIAL) {
                <div><mat-spinner strokeWidth="5"></mat-spinner></div>
              }
            </div>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (representationControl.value == viewRepresentation.TEXTURED && (isTilesetLoading$ | async)) {
      <mat-spinner class="view-selected-spinner" strokeWidth="5"></mat-spinner>
    }
    @if (representationControl.value == viewRepresentation.POINT_CLOUD && (isTilesetLoading$ | async)) {
      <mat-spinner class="view-selected-spinner" strokeWidth="5"></mat-spinner>
    }
    @if (representationControl.value == viewRepresentation.SPLITTED_TEXTURED && (isSplittedTilesetLoading$ | async)) {
      <mat-spinner class="view-selected-spinner" strokeWidth="5"></mat-spinner>
    }
    @if (representationControl.value == viewRepresentation.SPLITTED_POINT_CLOUD && (isSplittedTilesetLoading$ | async)) {
      <mat-spinner class="view-selected-spinner" strokeWidth="5"></mat-spinner>
    }
    @if (representationControl.value == viewRepresentation.DIFFERENTIAL && ((isTilesetLoading$ | async) || tilesetConfigComputing)) {
      <mat-spinner class="view-selected-spinner" strokeWidth="5"></mat-spinner>
    }
    <!--  <table>-->
    <!--    <tr><td>viewRepresentation</td><td>{{representationControl.value}}</td></tr>-->
    <!--    <tr><td>tilesetIsLoading</td><td>{{(isTilesetLoading$ | async)}}</td></tr>-->
  <!--  </table>-->
</div>
}
